import showVideo from '../libs/youtube'

export default context => {
    if (!('ontouchstart' in document.documentElement)) {
        $('.field-link a[href*="youtu"]', context)
            .on('click', function (event) {
                event.preventDefault();
                showVideo($(this).attr('href'), $(this).data('title'))
                return false
            })
            .attr('aria-haspopup', 'true')
    }
}
